export const EMPTY_CELL_VALUE = '-';
